export default __webpack_public_path__ + "static/gizapedia_logo-fd4ef4cca898a9e3206708bd0ef6d042.jpg";